import { optimizePeaks } from 'ml-gsd';
export function xyPeaksOptimization(data, peaks, options) {
    return optimizePeaks(data, peaks, options);
}
//# sourceMappingURL=xyPeaksOptimization.js.map